import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { LegalPageLayout } from '../components/LegalPageLayout';
import { SiteHeader } from '../components/SiteHeader';
import { AppFooter } from '../components/AppFooter';
export function AccessibilityStatement() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-169">
      <Helmet data-id="element-170">
        <title data-id="element-171">Accessibility Statement | Affordable Medical Tourism</title>
        <meta name="description" content="Our commitment to digital accessibility and WCAG 2.2 AA conformance for affordablemedicaltourism.com, a product of Kosansh Solutions Inc." data-id="element-172" />
        <link rel="canonical" href="https://affordablemedicaltourism.com/accessibility-statement" data-id="element-173" />
      </Helmet>

      <SiteHeader brand="Affordable Medical Tourism" links={[{
      label: 'Procedures',
      href: '/procedures'
    }, {
      label: 'How it works',
      href: '/how-it-works'
    }, {
      label: 'Destinations',
      href: '/destinations'
    }, {
      label: 'FAQ',
      href: '/faq'
    }]} contactCtaLabel="Get a free quote" onContactCta={() => navigate('/contact')} data-id="element-174" />

      <main className="flex-1" data-id="element-175">
        <LegalPageLayout title="Accessibility Statement" lastUpdated="June 11, 2026" illustrative={true} intro={<p className="text-lg text-slate-600 mb-8" data-id="element-177">
              Kosansh Solutions Inc is committed to ensuring that
              affordablemedicaltourism.com is accessible to the widest possible
              audience, regardless of ability or technology. We believe that
              equitable access to health information is a fundamental principle,
              and we work continuously to maintain and improve the accessibility
              of our digital experience.
            </p>} sections={[{
        id: 'commitment',
        heading: '1. Our Commitment',
        body: <div className="space-y-4 text-slate-600" data-id="element-178">
                  <p data-id="element-179">
                    We strive to conform to the Web Content Accessibility
                    Guidelines (WCAG) 2.2 at the AA level. These guidelines
                    explain how to make web content more accessible for people
                    with a wide array of disabilities, including visual,
                    auditory, physical, speech, cognitive, and neurological
                    conditions.
                  </p>
                  <p data-id="element-180">
                    Accessibility is treated as an ongoing commitment rather
                    than a one-time exercise. As we add new pages and features,
                    we evaluate them against recognized accessibility standards
                    before and after release.
                  </p>
                </div>
      }, {
        id: 'measures',
        heading: '2. Measures We Take',
        body: <div className="space-y-4 text-slate-600" data-id="element-181">
                  <p data-id="element-182">
                    To support accessibility, our site is built with the
                    following practices in mind:
                  </p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-183">
                    <li data-id="element-184">
                      Semantic HTML landmarks, including header, navigation,
                      main, and footer regions, to support assistive
                      technologies.
                    </li>
                    <li data-id="element-185">
                      A logical heading structure with a single primary heading
                      on each page.
                    </li>
                    <li data-id="element-186">Descriptive alternative text for meaningful images.</li>
                    <li data-id="element-187">
                      Keyboard operability for navigation menus, accordions, and
                      interactive controls.
                    </li>
                    <li data-id="element-188">
                      Visible focus indicators so keyboard users can track their
                      position.
                    </li>
                    <li data-id="element-189">Color combinations selected with contrast in mind.</li>
                  </ul>
                </div>
      }, {
        id: 'limitations',
        heading: '3. Known Limitations',
        body: <div className="space-y-4 text-slate-600" data-id="element-190">
                  <p data-id="element-191">
                    Despite our best efforts, some content may not yet be fully
                    accessible. Where third-party content or components are
                    used, we may have limited control over their conformance. We
                    document these areas and prioritize remediation as part of
                    our regular review cycle.
                  </p>
                </div>
      }, {
        id: 'feedback',
        heading: '4. Feedback and Contact',
        body: <div className="space-y-4 text-slate-600" data-id="element-192">
                  <p data-id="element-193">
                    We welcome your feedback on the accessibility of our
                    website. If you encounter a barrier or need information
                    provided in an alternative format, please reach out through
                    our secure contact form. For security and privacy reasons,
                    we do not publish direct email addresses, and all
                    communications are handled through that form.
                  </p>
                  <p data-id="element-194">
                    Kosansh Solutions Inc
                    <br data-id="element-195" />
                    Fort Worth, TX
                    <br data-id="element-196" />
                    Phone: 857-567-2674
                  </p>
                </div>
      }]} data-id="element-176" />
      </main>

      <AppFooter data-id="element-197" />
    </div>;
}